import { Spacing } from '@persona-id/design-tokens';
import { ComponentProps } from 'react';
import styled from 'styled-components';

import TemplateSelector from 'dashboard/components/TemplateSelector/TemplateSelector';

type TemplateSelectorProps = ComponentProps<typeof TemplateSelector>;

// This component is only used within the Theme Editor
export default (props: TemplateSelectorProps) => <TemplateSelectorWithPadding {...props} />;

const TemplateSelectorWithPadding = styled(TemplateSelector)`
  padding-top: ${Spacing[6]};
  padding-left: ${Spacing[4]};
  padding-right: ${Spacing[4]};
`;
